import React from 'react';
type BadgeVariant = 'hit' | 'new' | 'sale' | 'top' | 'default';
interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}
const variantStyles: Record<BadgeVariant, string> = {
  hit: 'bg-amber-500 text-white shadow-lg',
  new: 'bg-emerald-500 text-white shadow-lg',
  sale: 'bg-red-500 text-white shadow-lg',
  top: 'bg-gray-900 text-white shadow-lg',
  default: 'bg-gray-100 text-gray-700'
};
export function Badge({
  children,
  variant = 'default',
  className = ''
}: BadgeProps) {
  return <span className={`
        inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-semibold
        ${variantStyles[variant]}
        ${className}
      `} data-id="element-311">
      {children}
    </span>;
}
export function getBadgeVariant(badge: string | undefined): BadgeVariant {
  switch (badge) {
    case 'Хіт продажів':
      return 'hit';
    case 'Новинка':
      return 'new';
    case 'Знижка':
      return 'sale';
    case 'Топ':
      return 'top';
    default:
      return 'default';
  }
}